export const types = {
  OPEN_MODAL: 'Modal/open',
  CLOSE_MODAL: 'Modal/close',
  PRE_CLOSE_MODAL: 'Modal/preClose',
  CANCEL_CLOSE_MODAL: 'Modal/cancelClose',
  CLOSE_ALL_MODALS: 'Modal/closeAll',
  REGISTER_MODAL: 'Modal/register',
  UNREGISTER_MODAL: 'Modal/unregister'
}

export default {
  openModal: function({ name, initialState = {} }) {
    return {
      type: types.OPEN_MODAL,
      name,
      initialState
    }
  },
  closeModal: function({ name, force }) {
    if (!force) {
      return {
        type: types.PRE_CLOSE_MODAL,
        name
      }
    }

    return {
      type: types.CLOSE_MODAL,
      name
    }
  },
  cancelClose: function({ name }) {
    return {
      type: types.CANCEL_CLOSE_MODAL,
      name
    }
  },
  closeAllModals: function() {
    return { type: types.CLOSE_ALL_MODALS }
  },
  registerModal: function(name) {
    return {
      type: types.REGISTER_MODAL,
      name
    }
  },
  unregisterModal: function(name) {
    return {
      type: types.UNREGISTER_MODAL,
      name
    }
  }
}
